module.exports = __webpack_public_path__ + "static/img/coming.abe1813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coming.png
// module id = 55Vl
// module chunks = 1